import useTrackingEventCapturer from './use-tracking-event-capturer'

export default useTrackingEventCapturer
